

















































import BaseFormEdit from '../../models/base.form.edit';
import { Component } from 'vue-property-decorator';

@Component({})
export default class Edit extends BaseFormEdit {
  form = { code: '',  g1: '', g2: '' } as any;
  get title() {
    return this.$t('Аллель') + ` ${this.form.code}`;
  }
}
